import i18n from 'i18next';
import englishTranslation from './components/LanguageSelector/EnglishTranslations';
import arabicTranslation from './components/LanguageSelector/ArabicTranslations';
import frenchTranslation from './components/LanguageSelector/FrenchTranslations';

const getInitialLang = () => {
	let search = window.location.search;
	let params = new URLSearchParams(search);
	const lang = params.get('lang');
	return lang ? lang : 'en';
}

i18n
	.init({
		// we init with resources
		resources: {
			en: {
				translations: englishTranslation,
			},
			ar: {
				translations: arabicTranslation,
			},
			fr: {
				translations: frenchTranslation,
			}
		},
		fallbackLng: 'en',
		debug: true,
		preload: ['en', 'ar', 'fr'],
		// have a common namespace used around the full app
		ns: ['translations'],
		defaultNS: 'translations',
		lng: getInitialLang(),
		keySeparator: false, // we use content as keys

		interpolation: {
			escapeValue: false, // not needed for react!!
			formatSeparator: ',',
		},

		react: {
			wait: true,
			useSuspense: false,
		},
	});

export default i18n;
